
import { defineComponent, PropType } from "vue";
import CiImgixLazy from "@components/base/imgix-lazy.vue";
import CiRouterLink from "@router/router-link.vue";
import { buildURL, BuildURLOptions } from "@utils/build-url";

export default defineComponent({
  name: "CiCompanyTile",
  components: { CiImgixLazy, CiRouterLink },
  props: {
    company: {
      type: Object as PropType<Companies.Tile>,
      required: true,
    },
    showCounts: {
      type: Boolean,
      default: false,
    },
    paddingClass: {
      type: String,
      default: "ci-content-padding",
    },
    withBorder: {
      type: Boolean,
      default: false,
    },
    additionalTracking: {
      type: Object as PropType<Nullable<{ [id: string]: string }>>,
      default: null,
    },
    context: {
      type: String as PropType<"content-sidebar" | "product-detail-page" | "start-page">,
      default: "",
    },
  },
  emits: ["tracking-click"],
  computed: {
    classes(): string {
      const borderClass = this.withBorder ? "with-border" : "";
      const contextClass = this.context ? "ci-company-tile--context_" + this.context : "";
      const classes = [this.paddingClass, borderClass, contextClass].filter((el) => el !== "");

      return classes.join(" ");
    },
    companyLogo(): string | null {
      return this.company?.company_logo || null;
    },
    logoSize(): number {
      if (this.context === "content-sidebar" || this.context === "product-detail-page") return 140;
      else if (this.context === "start-page") return 128;

      return 230;
    },
    logoParams(): Indexable<string> {
      const params = { height: "78", fit: "clamp", dpr: "2" };
      if (this.context === "content-sidebar" || this.context === "product-detail-page") params.height = "80";
      else if (this.context === "start-page") params.height = "64";

      return params;
    },
    linkWithTracking(): string {
      if (this.company?.company_url) {
        const urlOptions: BuildURLOptions = {};
        if (this.context === "start-page") urlOptions["anchor"] = "#company-profile-articles";
        if (this.additionalTracking) urlOptions["searchParams"] = this.additionalTracking;

        return buildURL(this.company.company_url, urlOptions);
      }

      return "";
    },
  },
});
